import {gql} from "@apollo/client";

export const CREATE_VOUCHER_CLEARING_DOWNLOAD_TASK = gql`
    mutation VoucherClearingMutation($filters: VoucherClearingFilterTypeInput) {
        createVoucherClearingDownloadTask(filters: $filters)
    }
`;

export interface VoucherClearingDownloadTaskResponse { 
    createVoucherClearingDownloadTask: string;
}